import React from 'react'
import ReactDOM from 'react-dom'
import Animation from 'blocks.simple/animation/animation'
import ModalMethods from './modal.local.methods'
import { ModalDefaultProps, ModalProps } from './modal.types'
import Icon from 'blocks.simple/icon/icon'
import { cn } from 'ethcss'
import styles from './modal.jcss'
import { layers } from 'blocks.app/config'
import { getThemeStyleValue } from 'theme/colors'
import { defaultThemeStyles } from 'blocks.simple/icon/icon.theme'
import { isHorizontalMenu } from '../../core/helpers/menu'
import translate from '../../core/translate'

const getIconColor = (p_: ModalProps): string => {
    if (p_.mod === 'black') {
        return 'white'
    }

    return p_.closeIconColor || getThemeStyleValue('ui', 'icon', 'main') || defaultThemeStyles.main
}

class Modal extends ModalMethods {
    static defaultProps: ModalDefaultProps = {
        open: false,
        mod: 'white',
        showCloseIcon: true,
        z: 1,
        name: '',
        closeIconSize: 30,
        transitionName: 'fade',
        modalClassName: '',
    }

    renderContent = () => {
        const p_ = this.props

        if (p_.sidebars) {
            return (
                <div className={styles.sidebarsWrapper}>
                    {p_.sidebars.left && (
                        <div className={cn(styles.sidebarsLeft, p_.leftSidebarClass)}>{p_.sidebars.left}</div>
                    )}
                    <div className={cn(styles.sidebarsContent, p_.contentClassName)}>{p_.children}</div>
                    {p_.sidebars.right && (
                        <div className={cn(styles.sidebarsRight, p_.rightSidebarClass)}>{p_.sidebars.right}</div>
                    )}
                </div>
            )
        } else {
            return <div className={cn(styles.content, p_.contentClassName)}>{p_.children}</div>
        }
    }
    renderModal = () => {
        const p_ = this.props
        let mod = p_.mod
        if (p_.sidebars) {
            mod = 'clear'
        }

        return (
            <div
                className={cn(
                    styles.wrapper,
                    isHorizontalMenu() ? styles.wrapper_h : '',
                    styles[mod],
                    p_.modalClassName ? p_.modalClassName : ''
                )}
                style={{ zIndex: p_.z * layers.modal }}
                key={'modalContent'}
            >
                {p_.useBackButton && (
                    <div className={styles.backButtonContainer}>
                        <div
                            className={styles.backButton}
                            onClick={() => {
                                if (p_.onClose) {
                                    p_.onClose()
                                }
                            }}
                        >
                            <Icon type={'backArrow'} size={20} /> <span>{translate('back')}</span>
                        </div>
                    </div>
                )}
                {p_.showCloseIcon && !p_.useBackButton && (
                    <div
                        className={`${styles.button} ${isHorizontalMenu() ? styles.button_h : ''}`}
                        style={p_.closeIconStyles || undefined}
                    >
                        <Icon
                            type="close_tiny"
                            color={getIconColor(p_)}
                            size={p_.closeIconSize}
                            onClick={function () {
                                if (p_.onClose) {
                                    p_.onClose()
                                }
                            }}
                        />
                    </div>
                )}

                {this.renderContent()}
            </div>
        )
    }

    render() {
        const p_ = this.props
        const Content = <Animation transitionName={p_.transitionName}>{p_.open ? this.renderModal() : null}</Animation>

        return ReactDOM.createPortal(Content, this.element)
    }
}

export default Modal
